export const sortBySeq = (a: { sortSeq: number }, b: { sortSeq: number }) => a.sortSeq - b.sortSeq;
